// @ts-nocheck
import React, {useState} from 'react'
import axios from 'axios'
import {getAdminToken} from '../modules/admin/auth/_requests'

const API_URL = process.env.REACT_APP_API_URL

// Admin-only: mint a password-free link to ONE profile's live fleet preview and
// hand it to the admin (clipboard + visible field, so it can be pasted into
// WhatsApp).
//
// The customer who opens it gets the full preview page for that profile — live
// screen, real clicking and typing into the bot's browser, and the page's own
// buttons — with no fleet-dashboard password. The token is an HMAC bound to the
// one profile id and the fleet re-checks it on every route it opens, so the link
// cannot reach the dashboard, the fleet list, or another customer's profile.
//
// Renders nothing without an admin token: a customer must never mint these.
export default function SharePreviewLinkButton({profileId, className = '', label = '🔗 קישור ללקוח'}) {
  const [busy, setBusy] = useState(false)
  const [url, setUrl] = useState('')
  const [err, setErr] = useState('')
  const [days, setDays] = useState(30)
  const [copied, setCopied] = useState(false)

  if (!getAdminToken()) return null

  const generate = async () => {
    setBusy(true); setErr(''); setCopied(false)
    try {
      const adminToken = getAdminToken()
      const res = await axios.get(`${API_URL}/profile-preview-link/${profileId}?days=${days}`, {
        headers: adminToken ? {'x-admin-token': adminToken} : {},
      })
      if (!res.data || !res.data.success) throw new Error((res.data && res.data.message) || 'failed')
      setUrl(res.data.url)
      // Clipboard needs a secure context; the field below is the fallback the
      // admin can select by hand when it isn't available.
      try {
        await navigator.clipboard.writeText(res.data.url)
        setCopied(true)
      } catch (e) { /* leave it in the field */ }
    } catch (e) {
      setErr((e.response && e.response.data && e.response.data.message) || e.message)
    }
    setBusy(false)
  }

  return (
    <span className={className}>
      <button
        type='button'
        className='btn btn-sm btn-light-success'
        onClick={generate}
        disabled={busy}
        title='צור קישור שהלקוח יכול לפתוח ללא סיסמה — מוגבל לפרופיל הזה בלבד'
      >
        {busy ? '…' : label}
      </button>
      <select
        className='form-select form-select-sm d-inline-block ms-2'
        style={{width: 'auto'}}
        value={days}
        onChange={(e) => setDays(Number(e.target.value))}
        title='תוקף הקישור'
      >
        <option value={1}>יום</option>
        <option value={7}>שבוע</option>
        <option value={30}>חודש</option>
        <option value={90}>3 חודשים</option>
      </select>
      {url && (
        <div className='mt-2'>
          <input
            className='form-control form-control-sm'
            readOnly
            value={url}
            onFocus={(e) => e.target.select()}
            dir='ltr'
          />
          <div className='text-muted fs-8 mt-1'>
            {copied ? '✓ הועתק ללוח' : 'בחר והעתק'} · תקף {days === 1 ? 'יום' : days + ' ימים'} · פותח את הפרופיל הזה בלבד
          </div>
        </div>
      )}
      {err && <div className='text-danger fs-8 mt-1'>✗ {err}</div>}
    </span>
  )
}
